/**
 * Costs History Tab Component
 *
 * Displays state transition history for pricepoints.
 * Shows lifecycle events (activate, expire) with full audit trail.
 *
 * Important: state-history does NOT have a pricepointTypeId field,
 * so we filter by entityType='pricepoint' to show all pricepoint history.
 * Type-specific history filtering would require backend changes.
 *
 * Features (all metadata-driven):
 * - Data fetching from /state-history/search
 * - Pagination, sorting, filtering
 * - Presets, search, advanced filters
 * - Column customization
 *
 * Note: The deletedAt filter comes from statetransitionhistory.yaml schema's
 * _meta.base_filters, which allows the "Show Deleted" toggle to work.
 */

import { MetadataTable } from '@/components/MetadataTable'

export function CostsHistoryTab() {
  return (
    <MetadataTable
      endpoint="/state-history"
      baseFilters={[
        { key: 'entityType', constraint_type: 'EQUAL', value: 'pricepoint' },
      ]}
    />
  )
}
